import { Component, effect, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { IonButton, IonCheckbox, IonItem, IonLabel } from '@ionic/angular/standalone';
import { CookieConsentService } from '../../../cookie-consent/cookie-consent.service';
import { TRANSLATE_IMPORTS } from '../../../i18n/translate-imports';

@Component({
  selector: 're-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  styleUrl: './cookie-banner.component.scss',
  imports: [IonButton, IonCheckbox, IonItem, IonLabel, RouterLink, ...TRANSLATE_IMPORTS],
})
export class CookieBannerComponent {
  readonly consent = inject(CookieConsentService);
  readonly customized = signal(false);
  readonly analyticsDraft = signal(true);

  constructor() {
    effect(() => {
      if (this.consent.preferencesOpen()) {
        this.customized.set(true);
        this.analyticsDraft.set(this.consent.consent()?.analytics ?? false);
      }
    });
  }

  toggleCustomize(): void {
    this.customized.update((v) => !v);
    if (this.customized()) {
      this.analyticsDraft.set(this.consent.consent()?.analytics ?? true);
    }
  }

  save(): void {
    this.consent.setAnalytics(this.analyticsDraft());
  }

  dismissCustomize(): void {
    if (this.consent.consent() !== null) {
      this.consent.bannerVisible.set(false);
      this.consent.preferencesOpen.set(false);
      this.customized.set(false);
      return;
    }
    this.customized.set(false);
  }
}
